export const LOGIN = "login";
export const SIGNUP = "signup";
export const CARD_NUMBER = "card_number";
export const SUBID = "subId";
export const OTP = "otp";
export const SELECTEDCARD = "selectedCard";
export const USERDATA = "userData";
export const UID = "UID";